(() => {
  const instances = new WeakMap();
  const initialize = (root) => root.querySelectorAll('[data-hero]').forEach((hero) => {
    if (instances.has(hero)) return;
    const slides = [...hero.querySelectorAll('[data-hero-slide]')];
    if (slides.length < 2) return;
    const controls = hero.querySelector('[data-hero-controls]');
    const dots = [...hero.querySelectorAll('[data-hero-goto]')];
    const reduced = matchMedia('(prefers-reduced-motion: reduce)');
    const events = new AbortController();
    const options = { signal: events.signal };
    const duration = Number(hero.dataset.interval) || 10000;
    let index = 0, frame = 0, remaining = duration, startedAt = 0;
    let stopped = hero.dataset.autoplay !== 'true' || reduced.matches;
    let focused = false, artHovered = false;
    const progress = (elapsed = 0) => {
      const value = Math.min(1, Math.max(0, (duration - remaining + elapsed) / duration));
      dots[index].style.setProperty('--hero-progress', value);
    };
    const stopTimer = () => {
      if (frame) { cancelAnimationFrame(frame); remaining = Math.max(0, remaining - (performance.now() - startedAt)); frame = 0; }
      progress();
    };
    const tick = (now) => {
      const elapsed = now - startedAt;
      progress(elapsed);
      if (elapsed >= remaining) { frame = 0; show(index + 1); }
      else frame = requestAnimationFrame(tick);
    };
    const schedule = () => {
      stopTimer();
      if (!stopped && !focused && !artHovered && !document.hidden && hero.isConnected) {
        startedAt = performance.now(); frame = requestAnimationFrame(tick);
      }
    };
    const show = (next) => {
      stopTimer(); index = (next + slides.length) % slides.length; remaining = duration; artHovered = false;
      slides.forEach((slide, i) => {
        slide.dispatchEvent(new CustomEvent('piranha:hero:reset'));
        // Keep the layers mounted so the outgoing campaign can dissolve smoothly.
        slide.toggleAttribute('data-active', i === index);
        slide.inert = i !== index;
        slide.setAttribute('aria-hidden', String(i !== index));
      });
      dots.forEach((dot, i) => { dot.setAttribute('aria-current', String(i === index)); dot.style.setProperty('--hero-progress', 0); });
      hero.dataset.activeSlide = String(index); progress(); schedule();
    };
    hero.addEventListener('piranha:hero:ready', event => {
      // A cold image load still gets the full rip, reveal and reading interval.
      if (event.target.closest('[data-hero-slide]') === slides[index]) {
        stopTimer(); remaining = duration; progress(); schedule();
      }
    }, options);
    hero.addEventListener('piranha:hero:hover', event => {
      if (event.target.closest('[data-hero-slide]') !== slides[index]) return;
      artHovered = event.detail.active; schedule();
    }, options);
    hero.querySelectorAll('[data-hero-step]').forEach((button) => button.addEventListener('click', () => show(index + Number(button.dataset.heroStep)), options));
    dots.forEach((button) => button.addEventListener('click', () => show(Number(button.dataset.heroGoto)), options));
    // Keyboard users can explore a slide without it moving away. Mouse hover and
    // pointer clicks keep the same clock running for the bar and the next slide.
    hero.addEventListener('focusin', () => { focused = !!hero.querySelector(':focus-visible'); schedule(); }, options);
    hero.addEventListener('pointerdown', () => { focused = false; schedule(); }, options);
    hero.addEventListener('focusout', (event) => { if (!hero.contains(event.relatedTarget)) { focused = false; schedule(); } }, options);
    hero.addEventListener('keydown', (event) => {
      if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') { event.preventDefault(); show(index + (event.key === 'ArrowRight' ? 1 : -1)); }
    }, options);
    document.addEventListener('visibilitychange', schedule, options);
    reduced.addEventListener('change', () => { stopped = true; schedule(); }, options);
    document.addEventListener('shopify:block:select', (event) => {
      const next = slides.findIndex((slide) => slide.dataset.blockId === event.detail.blockId);
      if (next >= 0) { stopped = true; show(next); }
    }, options);
    instances.set(hero, () => { stopTimer(); events.abort(); });
    hero.dataset.heroReady = ''; controls.hidden = false; show(0);
  });
  initialize(document);
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
  document.addEventListener('shopify:section:unload', (event) => event.target.querySelectorAll('[data-hero]').forEach((hero) => instances.get(hero)?.()));
})();
